import { styled } from 'linaria/react';
import { css } from 'linaria';

export const RoomsParamsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-150);
  width: 100%;
  margin-bottom: var(--space-150);

  @media (--only-tablet) {
    margin-bottom: var(--space-50);
  }
`;

export const CalculatedRoomsContainer = styled.div`
  display: flex;
  gap: var(--space-100);

  @media (--to-tablet) {
    flex-wrap: nowrap;
    & > div {
      flex-wrap: nowrap;
      height: 103px;
      overflow-x: scroll;
      overflow-y: hidden;
      scroll-snap-type: x mandatory;

      button {
        scroll-snap-align: center;
        min-width: 224px;
      }
    }
  }
`;

export const SelectionGroupClassname = css`
  width: 100%;
`;

export const SelectionGroupItemClassname = css`
  width: 100%;
  max-width: 224px;
  max-height: 80px;
`;

export const RoomParametersWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
`;
